import React, { useState } from "react";
import { Form, Col, ControlLabel, FormControl, Row } from "react-bootstrap";
import { Group } from "../../utils/types";

type UserListColProps = {
  groups: Group[];
  disabled?: boolean;
  onFetchUsers: (group: string, query: string) => void;
};

function UserListCol({
  groups,
  disabled = false,
  onFetchUsers,
}: UserListColProps) {
  const [group, setGroup] = useState("All");
  const [query, setQuery] = useState("");

  return (
    <>
      <Col sm={12} className="App">
        <div className="rsi-title">Get user list settings</div>
        <Form horizontal>
          <Row>
            <Col componentClass={ControlLabel} sm={2}>
              <label>group</label>
            </Col>
            <Col sm={10}>
              <FormControl
                data-testid="groupSelect" //TODO: testIdに頼らないようにMTを修正する
                id="groupSelect"
                componentClass="select"
                value={group}
                onChange={(event: any) => {
                  setGroup(event.target.value);
                }}
              >
                {[
                  <option key="domain" value="All">
                    All
                  </option>,
                  ...groups.map((group: any) => {
                    return (
                      <option key={group.id} value={group.email}>
                        {group.name} : {group.email}
                      </option>
                    );
                  }),
                ]}
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col componentClass={ControlLabel} sm={2}>
              <label>query</label>
            </Col>
            <Col sm={10}>
              <FormControl
                data-testid="queryInput" //TODO: testIdに頼らないようにMTを修正する
                id="queryInput"
                type="text"
                value={query}
                onChange={(event: any) => {
                  setQuery(event.target.value);
                }}
                placeholder="directManager='bobjones@example.com'"
              />
            </Col>
          </Row>
          <button
            className="rsi-button is-primary"
            id="getUserButton"
            type="button"
            disabled={disabled}
            onClick={() => {
              onFetchUsers(group, query);
            }}
          >
            Get User List
          </button>
        </Form>
      </Col>
    </>
  );
}

export default UserListCol;
